import { LegendToggle } from '@mui/icons-material';
import { Divider, IconButton, ListItem, Menu, Tooltip, Typography } from '@mui/material';
import { LoadingIndicator } from '@qfa/react-components';
import { MapLegends } from 'kinetic/modules';
import { memo, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { MapLegendContext } from './MapLegendContext';
import useMapLegendStyles from './style';
import { MapLegendProps } from './types';
import { useMapLegendContext } from './useMapLegendContext';
import { useRenderLazy } from 'kinetic/useRenderLazy';

const MapLegend: React.FunctionComponent<MapLegendProps> = () => {
  const { t } = useTranslation(['maps', 'common']);
  const classes = useMapLegendStyles();
  const mapLegendContextValue = useMapLegendContext();
  const { open, anchorEl, handleClick, handleClose } = mapLegendContextValue;

  const mapLegends = useRenderLazy({ imports: MapLegends });

  const renderMapLegend = () => (
    <MapLegendContext.Provider value={mapLegendContextValue}>
      <Tooltip title={t('mapLegend')}>
        <IconButton onClick={handleClick} id='mapLegendMenuButton' className={classes.button}>
          <LegendToggle fontSize='small' />
        </IconButton>
      </Tooltip>
      <Menu
        id='mapLegendMenu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className={classes.menu}
        PaperProps={{
          className: classes.menuPaper,
        }}
      >
        <ListItem className={classes.menuHeader}>
          <Typography variant='h6'>{t('mapLegend')}</Typography>
        </ListItem>
        <Divider />
        <Suspense fallback={<LoadingIndicator />}>{mapLegends}</Suspense>
      </Menu>
    </MapLegendContext.Provider>
  );

  return renderMapLegend();
};

export default memo(MapLegend);
